'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadFreeTrialPromotion = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.doLoadFreeTrialPromotion = doLoadFreeTrialPromotion;
exports.loadSaga = loadSaga;
exports.watchSaga = watchSaga;

var _effects = require('redux-saga/effects');

var _promotions = require('constants/promotions');

var _planSelection = require('components/CmsPage/modules/PlanSelection/plan-selection.saga');

var _location = require('containers/LocationModal/location.saga');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(doLoadFreeTrialPromotion),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(loadSaga),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(watchSaga);

var loadFreeTrialPromotion = exports.loadFreeTrialPromotion = function loadFreeTrialPromotion(msa) {
  return {
    type: 'FREE_TRIAL_LOAD_PROMOTION_DATA', msa: msa
  };
};

function doLoadFreeTrialPromotion(client, _ref) {
  var msa = _ref.msa;
  return _regenerator2.default.wrap(function doLoadFreeTrialPromotion$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.call)(_planSelection.doLoadPromotionData, client, msa, _promotions.GET_CLASSPASS_DEFAULT_PROMOTION_ALIAS);

        case 2:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function loadSaga(client) {
  var msa;
  return _regenerator2.default.wrap(function loadSaga$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.call)(_location.getMsa, client);

        case 2:
          msa = _context2.sent;
          _context2.next = 5;
          return (0, _effects.call)(doLoadFreeTrialPromotion, client, { msa: msa });

        case 5:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function watchSaga(client) {
  return _regenerator2.default.wrap(function watchSaga$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.fork)(_effects.takeEvery, loadFreeTrialPromotion().type, doLoadFreeTrialPromotion, client);

        case 2:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}